import { z } from "zod";

// Shared line item schema used by invoices and estimates
export const LineItemSchema = z.object({
  description: z.string(),
  unit_price: z.number(),
  quantity: z.number(),
  amount: z.number(),
  // Grouping metadata (optional, for invoice display)
  shift_name: z.string().optional(),
  shift_id: z.string().optional(),
  position_name: z.string().optional(),
  shift_start: z.string().optional(),
  time_in: z.string().optional(), // ISO datetime
  time_out: z.string().optional(), // ISO datetime
  admin_fee: z.number().optional(), // percentage
  discount: z.number().optional(), // percentage
});

export type LineItem = z.infer<typeof LineItemSchema>;
